<div class="member-results-overlay">
  <h2 class="m-t-20">Search Results</h2>
  <div class="d-flex justify-content-center align-items-center">
    <h4>"{{ searchResults.query }}"</h4>
    <fa-icon class="m-l-10 pointer" icon="times" (click)="closeClicked.next(true)"></fa-icon>
  </div>

  <div class="row">
    <div class="col-md-6 offset-md-3">
      @for (member of searchResults.results; track member) {
        @if (member.id) {
          <div class="list-item hover text-left" [routerLink]="['/profile', member.id]">
            <div class="list-item-container">
              <img [src]="member.photo || './assets/images/default_avatar.jpg'" class="item-image align-center round image-border" />
              <div class="main-data">
                <span class="bold">{{ member.firstName + " " + member.lastName }}</span>
                <br />
                <span class="sub-data">
                  @if (member.tagline) {
                    <span>{{ member.tagline }}</span>
                  }
                  @if (member.skillsQueryMap) {
                    <div class="text-muted">
                      Skills:
                      @for (skill of member.skillsQueryMap; track skill; let i = $index) {
                        <span>{{ communityService.skillsMap[skill]?.title + (i == member.skillsQueryMap.length - 1 ? "" : ",") }}</span>
                      }
                    </div>
                  }
                </span>
              </div>
              <div class="right-data-buttons">
                <fa-icon icon="chevron-right"></fa-icon>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
